/**
 * RockPot Scroll Reveal
 * Adds subtle fade-in-up animation to sections as they enter viewport.
 */
document.addEventListener('DOMContentLoaded', function () {
  // Select all main sections for reveal
  var sections = document.querySelectorAll(
    '.hero-section, .trust-bar-section, .press-logos-section, ' +
    '.how-it-works-section, .social-proof-section, .use-cases-section, ' +
    '.featured-product-section, .rocktablet-section, .field-stories-section, ' +
    '.newsletter-section'
  );

  // Add reveal class to each section's first child
  sections.forEach(function (section) {
    var inner = section.querySelector('.container, .hero-content');
    if (inner) {
      inner.classList.add('reveal');
    }
  });

  // Intersection Observer for revealing
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });

  document.querySelectorAll('.reveal').forEach(function (el) {
    observer.observe(el);
  });

  // Sticky nav shadow
  var nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 10);
    });
  }
});
